import SectionBasic from './SectionBasic';
import styles from './FAQs.module.scss';

export default function FAQs({ data }) {
    return <SectionBasic data={data} styles={styles} />;
}
